import { render, staticRenderFns } from "./individual_goodnews_poster.vue?vue&type=template&id=525ae0a3&scoped=true"
import script from "./individual_goodnews_poster.vue?vue&type=script&lang=js"
export * from "./individual_goodnews_poster.vue?vue&type=script&lang=js"
import style0 from "./individual_goodnews_poster.vue?vue&type=style&index=0&id=525ae0a3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525ae0a3",
  null
  
)

export default component.exports